import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Loader } from '@grandvisionhq/common';
import '@grandvisionhq/utils';
import { usePaymentsUIContext } from '../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import { useRenderQrForm } from '../../hooks/use-render-qr-form.js';
import '../../models/adyen/payment-type.js';
import '../../models/cart-payment-methods/cart-payment-methods.js';
import { PaymentFlow } from '../../models/payment/types.js';
import '../../models/paypal/context.js';
import { useGetPaymentMethodList } from './hooks/use-get-payment-method-list.js';
import { PaymentMethodsUI } from './PaymentMethodsUI.js';
import { paymentMethodWithForm } from './Payments/providers.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/iris-ui';

const PaymentMethodsUIContainer = ({ paymentMethodName , onPaymentMethodSelected , onHandlePayment , cartId , addAdditionalPaymentCosts , qrCodeForm , orderInProgress , selectedDonation , onDonationSelected , totalPrice  })=>{
    const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState('');
    const { setIsProcessingOrder  } = usePaymentsUIContext();
    const [renderQrForm] = useRenderQrForm();
    React.useEffect(()=>{
        setIsProcessingOrder(orderInProgress);
    // We only need to listen for change in orderInProgress
    // adding setIsProcessingOrder in dep will result in extra re-render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        orderInProgress
    ]);
    const handleQrRefresh = React.useCallback(()=>{
        onHandlePayment({
            type: selectedPaymentMethod,
            isValid: true,
            data: {}
        });
    }, [
        onHandlePayment,
        selectedPaymentMethod
    ]);
    /**
   * QR scanner component when user selects QR supported payment method
   */ const qrComponent = React.useMemo(()=>{
        return qrCodeForm.orderToken && qrCodeForm.qrPaymentConfig && qrCodeForm.paymentFlow === PaymentFlow.QR_CODE ? renderQrForm(swcHelpers.objectSpread({}, qrCodeForm, {
            handleRefreshQrCode: handleQrRefresh,
            cart: cartId ? {
                id: cartId
            } : null
        })) : null;
    }, [
        handleQrRefresh,
        qrCodeForm,
        renderQrForm,
        cartId
    ]);
    const isPaymentActionValid = React.useCallback((paymentConfig)=>{
        if (!paymentConfig) {
            return paymentMethodWithForm(selectedPaymentMethod) ? false : true;
        } else {
            return Boolean(paymentConfig === null || paymentConfig === void 0 ? void 0 : paymentConfig.isValid);
        }
    }, [
        selectedPaymentMethod
    ]);
    const onPaymentAction = React.useCallback((paymentConfig)=>{
        onHandlePayment(swcHelpers.objectSpread({}, paymentConfig, {
            isValid: isPaymentActionValid(paymentConfig),
            type: selectedPaymentMethod
        }));
    }, [
        onHandlePayment,
        selectedPaymentMethod,
        isPaymentActionValid
    ]);
    const [paymentMethodItems, _, resetPaymentDetails, additionalCosts, { loading , data: paymentMethods  }, ] = useGetPaymentMethodList(cartId, onPaymentAction, selectedDonation, onDonationSelected, totalPrice);
    const handleChange = React.useCallback((selectedPaymentMethodType)=>{
        const selectedPaymentMethodConfig = paymentMethods.filter((item)=>item.name == selectedPaymentMethodType
        )[0];
        selectedPaymentMethodConfig && onPaymentMethodSelected({
            type: selectedPaymentMethodConfig.name,
            provider: selectedPaymentMethodConfig.provider,
            config: selectedPaymentMethodConfig.donations ? {
                name: selectedPaymentMethodConfig.name,
                provider: selectedPaymentMethodConfig.provider,
                donations: selectedPaymentMethodConfig.donations,
                brands: 'brands' in selectedPaymentMethodConfig ? selectedPaymentMethodConfig.brands : []
            } : undefined
        });
        resetPaymentDetails();
        // Handle logic for cash on delivery here
        if (paymentMethodName !== selectedPaymentMethodType && selectedPaymentMethodConfig) {
            addAdditionalPaymentCosts({
                type: selectedPaymentMethodType,
                provider: selectedPaymentMethodConfig.provider
            }, additionalCosts);
        }
        setSelectedPaymentMethod(selectedPaymentMethodType);
    }, [
        paymentMethods,
        onPaymentMethodSelected,
        resetPaymentDetails,
        paymentMethodName,
        addAdditionalPaymentCosts,
        additionalCosts, 
    ]);
    React.useEffect(()=>{
        if (paymentMethods.length && selectedPaymentMethod === '' && paymentMethodName.length) {
            handleChange(paymentMethodName);
        }
    // excluding  handleChange from dep to prevent extra re-render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        paymentMethodName,
        paymentMethods,
        selectedPaymentMethod
    ]);
    if (!paymentMethodItems.length || loading) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PaymentMethodsUI, {
        handleChange: handleChange,
        paymentMethodItems: paymentMethodItems,
        selectedPaymentMethodType: selectedPaymentMethod
    }), qrComponent);
};

export { PaymentMethodsUIContainer };
//# sourceMappingURL=PaymentMethodsUIContainer.js.map
